import React from 'react'
import PropTypes from 'prop-types'

import ColorSwatch from './color-swatch'
import QuantitySwatch from './quantity-swatch'
import {Flex, useStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'

const SwatchSection = ({swatchInfo = []}) => {
    const styles = useStyleConfig('ProductTile', {})
    const isSwatchAlt = swatchInfo?.[0]?.swatch?.swatchType === 'alternative'
    const iAltSingleItem = swatchInfo.length <= 1
    const isSwatchColor = swatchInfo?.[0]?.swatch?.swatchType === 'color'
    const hasVariants = swatchInfo?.length > 0

    return (
        <>
            {hasVariants ? (
                isSwatchColor ? (
                    <Flex {...styles?.colorSwatchContainer} data-testid="color-swatch-container">
                        <ColorSwatch enabledVariants={swatchInfo} />
                    </Flex>
                ) : isSwatchAlt ? (
                    <Flex
                        {...styles?.colorSwatchContainer}
                        width="fit-content"
                        data-testid="quantiy-swatch-container"
                        alignItems={iAltSingleItem ? 'center' : 'flex-start'}
                    >
                        <QuantitySwatch enabledVariants={swatchInfo} />
                    </Flex>
                ) : (
                    <></>
                )
            ) : null}
        </>
    )
}

SwatchSection.propTypes = {
    swatchInfo: PropTypes.array,
}

export default SwatchSection
